import { render, staticRenderFns } from "./MouseMoneyPrizeRecordTable.vue?vue&type=template&id=3e5892ce&scoped=true&"
import script from "./MouseMoneyPrizeRecordTable.vue?vue&type=script&lang=js&"
export * from "./MouseMoneyPrizeRecordTable.vue?vue&type=script&lang=js&"
import style0 from "./MouseMoneyPrizeRecordTable.vue?vue&type=style&index=0&id=3e5892ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5892ce",
  null
  
)

export default component.exports